import { render, staticRenderFns } from "./JigDateTimeFields.vue?vue&type=template&id=6bb51bdc"
import script from "./JigDateTimeFields.vue?vue&type=script&lang=ts"
export * from "./JigDateTimeFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports